export default "__VITE_ASSET__DXKyU7Cj__"